import { render, staticRenderFns } from "./appMyEducations.vue?vue&type=template&id=16ca6f00&scoped=true"
import script from "./appMyEducations.vue?vue&type=script&lang=js"
export * from "./appMyEducations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ca6f00",
  null
  
)

export default component.exports